module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "socrates.fb416e7c.png";